export const GA_MID = "G-LC21VTWD8Y"; // DCSD
// export const GA_MID = "G-M472V88STX"; // employee dashboard - GA-4
